Vue.directive('redirect', { inserted: function (el) {

        el.addEventListener('change', function (e) {

            document.location.href = el.value;
        });
    }
});
